(() => {
  'use strict';
  if (window.bpStorefrontLoaded) return;
  window.bpStorefrontLoaded = true;
  window.bpTrack = (name, data = {}) => {
    if (!window.bpAnalyticsEnabled) return;
    try {
      if (window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() !== true) return;
      const published = window.Shopify?.analytics?.publish?.(`book_protectors:${name}`, data);
      published?.catch?.(() => {});
    } catch (_) { /* Measurement and ordering never depend on analytics. */ }
  };
  if (window.bpAnalyticsEnabled && window.Shopify?.loadFeatures) {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], () => {});
  }
  class CoverGuide extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const form = this.querySelector('form'), result = this.querySelector('[data-guide-result]');
      const data = JSON.parse(this.querySelector('[data-guide-data]').textContent);
      const book = form.elements.book, finish = form.elements.finish;
      const update = () => {
        this.querySelector('[data-preference]').hidden = book.value !== 'paperback';
        result.hidden = true;
      };
      form.addEventListener('change', update); update();
      form.addEventListener('submit', event => {
        event.preventDefault();
        const key = book.value === 'dustjacket' ? 'dustjacket' : book.value === 'hardback' || finish.value === 'removable' ? 'lyfjackets' : finish.value === 'rigid' ? 'lyfguards' : 'film';
        // Exercise jackets are a paperback option, not a hardback recommendation.
        const items = book.value === 'hardback' ? data[key].slice(0, 1) : data[key];
        result.replaceChildren();
        items.forEach(item => {
          const article = document.createElement('article');
          const heading = document.createElement('h3'); heading.textContent = item.title;
          const description = document.createElement('p'); description.textContent = item.description;
          article.append(heading, description);
          const links = document.createElement('div'); links.className = 'bp-guide__links';
          (item.links || [{ url: item.url, label: 'Explore this range →' }]).forEach(target => {
            const link = document.createElement('a'); link.href = target.url; link.textContent = target.label;
            links.append(link);
          });
          article.append(links); result.append(article);
        });
        result.hidden = false;
        window.bpTrack('range_recommended', { range: key, book_type: book.value });
      });
    }
  }
  class QuickOrder extends HTMLElement {
    connectedCallback() {
      if (this.ready) return; this.ready = true;
      const form = this.querySelector('form'), rows = [...this.querySelectorAll('[data-quick-row]')];
      const status = this.querySelector('[data-quick-status]'), button = form.querySelector('button[type="submit"]');
      const inputs = [...form.querySelectorAll('[data-variant]')];
      this.querySelector('[data-quick-search]').addEventListener('input', event => {
        const query = event.target.value.trim().toLowerCase();
        rows.forEach(row => { row.hidden = !row.dataset.search.toLowerCase().includes(query); });
        const count = rows.filter(row => !row.hidden).length;
        this.querySelector('[data-quick-count]').textContent = count ? `${count} options shown. Quantities on hidden rows are still included.` : 'No matching sizes. Clear the search to see all options.';
      });
      form.addEventListener('submit', async event => {
        event.preventDefault(); if (this.busy) return;
        const items = []; let invalid;
        inputs.forEach(input => {
          if (input.disabled) return;
          const quantity = input.value === '' ? 0 : Number(input.value);
          const minimum = Number(input.dataset.minimum || 1), increment = Number(input.step || 1);
          const maximum = input.max ? Number(input.max) : Infinity;
          const valid = Number.isSafeInteger(quantity) && quantity >= 0 && (quantity === 0 || (quantity >= minimum && quantity <= maximum && quantity % increment === 0));
          input.setAttribute('aria-invalid', String(!valid));
          if (!valid) { invalid ||= input; return; }
          if (quantity > 0) items.push({ id: input.dataset.variant, quantity });
        });
        if (invalid) {
          invalid.closest('tr').hidden = false;
          status.textContent = 'Check the highlighted quantity. Use a whole number within the allowed quantity and pack increments.';
          invalid.focus(); return;
        }
        if (!items.length) { status.textContent = 'Enter a quantity for at least one size.'; return; }
        this.busy = true; button.disabled = true; status.textContent = 'Adding your selected sizes…';
        try {
          const response = await fetch(this.dataset.addUrl, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items }) });
          const data = await response.json();
          if (!response.ok || data.status) throw new Error(typeof data.description === 'string' ? data.description : 'Some sizes could not be added.');
          inputs.filter(input => !input.disabled).forEach(input => { input.value = '0'; });
          status.textContent = 'Your sizes have been added. Opening your basket…';
          this.querySelector('[data-view-cart]').hidden = false;
          window.bpTrack('quick_order_added', { variants: items.length, quantity: items.reduce((sum, item) => sum + item.quantity, 0) });
          window.location.assign(this.dataset.cartUrl);
        } catch (error) {
          status.textContent = `${error.message || 'We could not confirm the result.'} Check your basket before trying again.`;
          this.querySelector('[data-view-cart]').hidden = false;
        } finally { this.busy = false; button.disabled = false; }
      });
    }
  }
  customElements.define('bp-cover-guide', CoverGuide);
  customElements.define('bp-quick-order', QuickOrder);
  function initialise(root = document) {
    root.querySelectorAll('[data-trade-search]').forEach(input => {
      if (input.dataset.ready) return; input.dataset.ready = 'true';
      const section = input.closest('.b2b-collections-section'); if (!section) return;
      const groups = [...section.querySelectorAll('.b2b-collection')];
      input.addEventListener('input', () => {
        const query = input.value.trim().toLowerCase(); let count = 0;
        groups.forEach(group => {
          const rows = [...group.querySelectorAll('.quick-buy-item')];
          rows.forEach(row => { row.hidden = !(row.dataset.search || row.textContent).toLowerCase().includes(query); if (!row.hidden) count++; });
          group.hidden = rows.length > 0 && rows.every(row => row.hidden);
        });
        section.querySelector('[data-trade-count]').textContent = count ? `${count} products match. Clear the search to show all ranges.` : 'No matching products. Try a product name or another size code.';
      });
    });
    root.querySelectorAll('[data-description-prices]').forEach(data => {
      if (data.dataset.ready) return; data.dataset.ready = 'true';
      const variants = JSON.parse(data.textContent);
      const description = data.closest('.product__description');
      description?.querySelectorAll('table').forEach(table => {
        const rows = [...table.querySelectorAll('tr')];
        const headers = [...(rows[0]?.querySelectorAll('th,td') || [])].map(cell => cell.textContent.trim().toLowerCase());
        const priceColumn = headers.findIndex(text => /^price(?:\s|$)/.test(text));
        if (priceColumn < 0 || !/^(code|size)/.test(headers[0] || '')) return;
        rows.slice(1).forEach(row => {
          const cells = row.querySelectorAll('th,td');
          if (!cells[priceColumn]) return;
          const code = cells[0].textContent.trim();
          const matches = variants.filter(variant => variant.options.some(option => option.trim() === code));
          const prices = [...new Set(matches.map(variant => variant.price))];
          cells[priceColumn].textContent = prices.length === 1 ? prices[0] : 'See product options';
        });
      });
    });
    const enquiry = root.querySelector('#ContactEnquiry');
    if (enquiry && new URLSearchParams(window.location.search).get('enquiry') === 'sizing') { enquiry.value = 'Sizing help'; const details = root.querySelector('.bp-contact-extra details'); if (details) details.open = true; }
  }
  initialise(); document.addEventListener('shopify:section:load', event => initialise(event.target));
})();
